import { render, staticRenderFns } from "./set_up_new_training.vue?vue&type=template&id=6668fc1a"
import script from "./set_up_new_training.vue?vue&type=script&lang=js"
export * from "./set_up_new_training.vue?vue&type=script&lang=js"
import style0 from "./set_up_new_training.vue?vue&type=style&index=0&id=6668fc1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports